<template>
  <div class="home">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ImageSlider category="36"></ImageSlider>
        <div v-html="homeContent"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import ImageSlider from '@/components/ImageSlider'
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import {BButton} from 'bootstrap-vue'
import PreContentHeader from '@/components/PreContentHeader'
export default {
  components: {
    PreContentHeader,
    ImageSlider,
    'b-btn': BButton
  },
  data () {
    return {
      homeContent: '',
      contentReady: false,
      contentLoadError: ''
    }
  },
  created () {
    document.title = this.$route.name + ' - ThinkTank'
    WordpressRestAPI.getViewContent('pages/29')
      .then(response => {
        this.homeContent = response.data.content.rendered
        this.contentReady = true
      })
      .catch(e => {
        this.contentLoadError = 'Oops! We had a problem with loading content for this page. Please try again later.'
        console.error(e)
        this.contentReady = true
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/Home.vue